























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

@Component

export default class ComponentModalSolicitacaoCirurgiaHeader extends Vue {
  @Prop(String) title

  @Emit('getShow')
  getShow(value) {

  }
}

